import useGetTransfers from './useGetTransfers'
import { DateTime } from 'luxon'

export default function useGetRecentCashActivity(accountNumber: string) {
  const twoWeeksAgo = DateTime.local().minus({ weeks: 2 })
  const today = DateTime.local()
  // show the previous two weeks of transfers
  const startDate = twoWeeksAgo.startOf('day').toUTC().toISO()
  const endDate = today.endOf('day').toUTC().toISO()
  const params = { since: startDate, before: endDate }
  return useGetTransfers(
    accountNumber,
    ['ACH', 'CASH_JOURNAL', 'FEE', 'CREDIT', 'CHECK', 'PAYPAL', 'WIRE', 'RTP'],
    params
  )
}
